export default __webpack_public_path__ + "static/media/1794_set_comp.e0c35d69.jpg";